// Copyright (c) Docugami, Inc. All rights reserved.

import { IDocumentCommand } from "components/file_management/DocumentCommand";
import { StorageProviderFilePicker } from "components/storage/StorageProviderFilePicker";
import { ProviderPickerItem } from "components/storage/ProviderPickerItem";
import { ProviderId, UploadDocumentsRequest, UploadItemDetails } from "networking/StorageProviders";
import { useState } from "react";
import { StorageManagerInstance } from "storage/StorageManager";

export function useStorageProviderUploadCommand(
    providerId: ProviderId | null,
    onComplete: (error?: any) => void,
    autoUpload: boolean,
    onItemsSelected?: (items: ProviderPickerItem[]) => void,
    docSetId?: string): IDocumentCommand {
    const [isActive, setIsActive] = useState(false);

    function onConfirm(items: ProviderPickerItem[]) {
        if (!!autoUpload && !!providerId) {
            const request: UploadDocumentsRequest = {
                providerId: providerId,
                items: items.map<UploadItemDetails>(x => {
                    return {
                        item: x.item,
                        isSynced: !!x.isSynced
                    }
                }),
                docSetId: docSetId
            }

            StorageManagerInstance.uploadRequest(request);
        }

        onItemsSelected?.(items);

        setIsActive(false);
        onComplete();
    }

    return {
        id: "storageProviderUpload",
        isActive: isActive,
        label: "Upload Docs",
        isEnabled: true,
        visual: !!providerId ? <StorageProviderFilePicker key={providerId} providerId={providerId} isOpen={isActive} onCancel={() => { setIsActive(false); onComplete() }} onConfirm={onConfirm} /> : null,
        execute: () => setIsActive(true)
    }
}
